import React from 'react'
import Login from '../components/Authentication/Login/Login'
import PublicRoute from '../components/PublicRoute'

export default () => {
    return <PublicRoute component={Login} />
}